export default __webpack_public_path__ + "static/media/crm_img1.258b5067.jpg";